module.exports = __webpack_public_path__ + "r-v3/img/ml_17_00.87fded0f.jpg";